<template>
  <main class="main recover-password max-width amateur">
    <article>
      <div id="partialUserResetForm">
        <h1 class="title-medium">Hai dimenticato la password?</h1>
        <p class="title-medium light">Inserisci la mail che hai utilizzato al momento della registrazione</p>

        <!-- data-request="resetPassword::onRestorePassword" data-request-update="'site/resetpassword/checkmail': '#partialUserResetForm'" -->
        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label for="userRestoreEmail">Email</label>
            <input name="email" id="userRestoreEmail" v-model="email" placeholder="Inserisci la tua email" />
            <!-- <input name="email" type="email" class="form-control" placeholder="Scrivi la tua email" ref="email"> -->
          </div>

          <button class="btn btn-default button-anim">RECUPERA PASSWORD</button>
        </form>

        <no-interaction-overlay 
          :isActive = "state && state == 'req-sent'"
          bgColor="azure"
          message="Stiamo verificando. Per favore, attendi.."
        ></no-interaction-overlay>
        
        <snackbar 
          :states="states" 
          :state="state"
          :showSnackbar="showSnackbar"
          @close="showSnackbar = false"
        ></snackbar>
      </div>
    </article>
  </main>
</template>

<script>
import * as Cookies from 'js-cookie';
import axios from 'axios/dist/axios';
import Snackbar from './Snackbar.vue';
import NoInteractionOverlay from './NoInteractionOverlay.vue';

export default {
  props: ['user', 'isCheckingLogin'],

  data() {
    return {
      state: undefined,
      states: [
        {name: 'success', message: 'La richiesta ha avuto successo. Segui le istruzioni che trovi nell\'email che ti abbiamo inviato', bgColor: 'aqua'},
        {name: 'failure', message: 'Attenzione: questa email non esiste nel nostro database utenti. Forse non è l\'indirizzo esatto?', bgColor: 'light_purple'}
      ],
      email: '',
      showSnackbar: false
    }
  },

  methods: {
    onSubmit: function(e) {
      this.state = 'req-sent';
      axios.post('/api/v1/user/restore_password', {email: this.email})
        .then(resp => {
          this.state = 'success';
          this.showSnackbar = true;
        })
        .catch(err => {
          this.state = 'failure';
          this.showSnackbar = true;
        });
    } 
  },

  components: {
    'snackbar': Snackbar,
    'no-interaction-overlay': NoInteractionOverlay
  },

  mounted() {
    document.title = 'Caramba - Hai dimenticato la password?';
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/components/Recover.vue